import { generateErrorMap } from "@saberhq/anchor-contrib";

export type ActivityIDL = {
  version: "0.1.0";
  name: "activity";
  instructions: [
    {
      name: "initialize";
      accounts: [
        {
          name: "activityMaster";
          isMut: true;
          isSigner: false;
        },
        {
          name: "caffeineTokenMint";
          isMut: false;
          isSigner: false;
        },
        {
          name: "authority";
          isMut: true;
          isSigner: true;
        },
        {
          name: "mintWrapper";
          isMut: false;
          isSigner: false;
        },
        {
          name: "minter";
          isMut: false;
          isSigner: false;
        },
        {
          name: "systemProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "rent";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [
        {
          name: "bump";
          type: "u8";
        },
        {
          name: "openRewardTimestamp";
          type: "i64";
        },
        {
          name: "secondPartyNum";
          type: "u8";
        },
        {
          name: "crmExchangeRate";
          type: "u64";
        },
        {
          name: "crmPriceDecimal";
          type: "u8";
        },
        {
          name: "url";
          type: "string";
        },
        {
          name: "multipliers";
          type: {
            array: ["u8", 5];
          };
        }
      ];
    },
    {
      name: "addTransferer";
      accounts: [
        {
          name: "activityMaster";
          isMut: true;
          isSigner: false;
        },
        {
          name: "authority";
          isMut: false;
          isSigner: true;
        }
      ];
      args: [
        {
          name: "idx";
          type: "u8";
        },
        {
          name: "exchangeRate";
          type: "u64";
        },
        {
          name: "decimals";
          type: "u8";
        },
        {
          name: "name";
          type: "string";
        }
      ];
    },
    {
      name: "update";
      accounts: [
        {
          name: "activityMaster";
          isMut: true;
          isSigner: false;
        },
        {
          name: "authority";
          isMut: false;
          isSigner: true;
        }
      ];
      args: [
        {
          name: "openRewardTimestamp";
          type: {
            option: "i64";
          };
        },
        {
          name: "url";
          type: {
            option: "string";
          };
        },
        {
          name: "opSecondPartyNum";
          type: {
            option: "u8";
          };
        },
        {
          name: "opCrmExchangeRate";
          type: {
            option: "u64";
          };
        },
        {
          name: "opCrmPriceDecimal";
          type: {
            option: "u8";
          };
        }
      ];
    },
    {
      name: "mint";
      accounts: [
        {
          name: "activityMaster";
          isMut: true;
          isSigner: false;
        },
        {
          name: "payerAccount";
          isMut: true;
          isSigner: true;
        },
        {
          name: "caffeineTokenMint";
          isMut: true;
          isSigner: false;
        },
        {
          name: "tokenAccount";
          isMut: true;
          isSigner: false;
        },
        {
          name: "mint";
          isMut: true;
          isSigner: true;
        },
        {
          name: "receiverAtaAccount";
          isMut: true;
          isSigner: false;
        },
        {
          name: "metadata";
          isMut: true;
          isSigner: false;
        },
        {
          name: "activityMetadata";
          isMut: true;
          isSigner: false;
        },
        {
          name: "tokenMetadataProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "associatedTokenProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "systemProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "rent";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [
        {
          name: "bump";
          type: "u8";
        },
        {
          name: "degree";
          type: "u8";
        }
      ];
    },
    {
      name: "upgradeNft";
      accounts: [
        {
          name: "activityMaster";
          isMut: true;
          isSigner: false;
        },
        {
          name: "payerAccount";
          isMut: true;
          isSigner: true;
        },
        {
          name: "caffeineTokenMint";
          isMut: true;
          isSigner: false;
        },
        {
          name: "tokenAccount";
          isMut: true;
          isSigner: false;
        },
        {
          name: "mint";
          isMut: false;
          isSigner: false;
        },
        {
          name: "nftAtaAccount";
          isMut: true;
          isSigner: false;
        },
        {
          name: "activityMetadata";
          isMut: true;
          isSigner: false;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [];
    },
    {
      name: "claimReward";
      accounts: [
        {
          name: "activityMaster";
          isMut: true;
          isSigner: false;
        },
        {
          name: "payerAccount";
          isMut: true;
          isSigner: true;
        },
        {
          name: "mint";
          isMut: false;
          isSigner: false;
        },
        {
          name: "nftAtaAccount";
          isMut: true;
          isSigner: false;
        },
        {
          name: "metadata";
          isMut: true;
          isSigner: false;
        },
        {
          name: "activityMetadata";
          isMut: true;
          isSigner: false;
        },
        {
          name: "mintWrapper";
          isMut: true;
          isSigner: false;
        },
        {
          name: "mintWrapperProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "minter";
          isMut: true;
          isSigner: false;
        },
        {
          name: "rewardsTokenMint";
          isMut: true;
          isSigner: false;
        },
        {
          name: "rewardsTokenAccount";
          isMut: true;
          isSigner: false;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "recentBlockhashAccount";
          isMut: false;
          isSigner: false;
        },
        {
          name: "instructionSysvarAccount";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [];
    },
    {
      name: "claimSecondParty";
      accounts: [
        {
          name: "activityMaster";
          isMut: true;
          isSigner: false;
        },
        {
          name: "payerAccount";
          isMut: true;
          isSigner: true;
        },
        {
          name: "mint";
          isMut: true;
          isSigner: false;
        },
        {
          name: "nftAtaAccount";
          isMut: true;
          isSigner: false;
        },
        {
          name: "metadata";
          isMut: true;
          isSigner: false;
        },
        {
          name: "activityMetadata";
          isMut: true;
          isSigner: false;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "transferWrapperProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "mintWrapper";
          isMut: true;
          isSigner: false;
        },
        {
          name: "mintWrapperProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "minter";
          isMut: true;
          isSigner: false;
        },
        {
          name: "rewardsTokenMint";
          isMut: true;
          isSigner: false;
        },
        {
          name: "rewardsTokenAccount";
          isMut: true;
          isSigner: false;
        }
      ];
      args: [];
    },
    {
      name: "claimCaffeine";
      accounts: [
        {
          name: "activityMaster";
          isMut: true;
          isSigner: false;
        },
        {
          name: "payerAccount";
          isMut: true;
          isSigner: true;
        },
        {
          name: "caffeineTokenMint";
          isMut: true;
          isSigner: false;
        },
        {
          name: "caffeineTokenAccount";
          isMut: true;
          isSigner: false;
        },
        {
          name: "rewardsTokenMint";
          isMut: true;
          isSigner: false;
        },
        {
          name: "rewardsTokenAccount";
          isMut: true;
          isSigner: false;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "mintWrapper";
          isMut: true;
          isSigner: false;
        },
        {
          name: "mintWrapperProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "minter";
          isMut: true;
          isSigner: false;
        }
      ];
      args: [
        {
          name: "burnAmount";
          type: "u64";
        }
      ];
    },
    {
      name: "closePdaAccount";
      accounts: [
        {
          name: "activityMaster";
          isMut: true;
          isSigner: false;
        },
        {
          name: "authority";
          isMut: false;
          isSigner: true;
        }
      ];
      args: [];
    }
  ];
  accounts: [
    {
      name: "ActivityMaster";
      type: {
        kind: "struct";
        fields: [
          {
            name: "authority";
            type: "publicKey";
          },
          {
            name: "caffeineTokenMint";
            type: "publicKey";
          },
          {
            name: "bump";
            type: "u8";
          },
          {
            name: "mintWrapper";
            type: "publicKey";
          },
          {
            name: "minter";
            type: "publicKey";
          },
          {
            name: "openRewardTimestamp";
            type: "i64";
          },
          {
            name: "secondPartyNum";
            type: "u8";
          },
          {
            name: "crmExchangeRate";
            type: "u64";
          },
          {
            name: "crmPriceDecimal";
            type: "u8";
          },
          {
            name: "url";
            type: "string";
          },
          {
            name: "cremaKeys";
            type: {
              vec: {
                defined: "CremaKey";
              };
            };
          },
          {
            name: "transfers";
            type: {
              vec: {
                defined: "TransferMeta";
              };
            };
          }
        ];
      };
    },
    {
      name: "ActivityMetadata";
      type: {
        kind: "struct";
        fields: [
          {
            name: "caffeine";
            type: "u64";
          },
          {
            name: "degree";
            type: "u8";
          },
          {
            name: "mint";
            type: "publicKey";
          },
          {
            name: "mintUser";
            type: "publicKey";
          },
          {
            name: "seed";
            type: "u8";
          },
          {
            name: "isCrmClaimed";
            type: "bool";
          },
          {
            name: "crmClaimedAmount";
            type: "u64";
          },
          {
            name: "isClaimed";
            type: {
              vec: "bool";
            };
          },
          {
            name: "claimAmounts";
            type: {
              vec: "u64";
            };
          }
        ];
      };
    }
  ];
  types: [
    {
      name: "CremaKey";
      type: {
        kind: "struct";
        fields: [
          {
            name: "level";
            type: "u8";
          },
          {
            name: "itemsMinted";
            type: "i64";
          },
          {
            name: "itemsNormalClaimed";
            type: "i64";
          },
          {
            name: "itemsLuckyClaimed";
            type: "i64";
          },
          {
            name: "multiplier";
            type: "u8";
          }
        ];
      };
    },
    {
      name: "TransferMeta";
      type: {
        kind: "struct";
        fields: [
          {
            name: "mint";
            type: "publicKey";
          },
          {
            name: "decimals";
            type: "u8";
          },
          {
            name: "transferWrapper";
            type: "publicKey";
          },
          {
            name: "transferer";
            type: "publicKey";
          },
          {
            name: "tokensClaimed";
            type: "u64";
          },
          {
            name: "exchangeRate";
            type: "u64";
          },
          {
            name: "priceDecimal";
            type: "u8";
          },
          {
            name: "name";
            type: "string";
          }
        ];
      };
    }
  ];
  events: [
    {
      name: "MintEvent",
      fields: [
        {
          name: "user",
          type: "publicKey",
          index: false,
        },
        {
          name: "mint",
          type: "publicKey",
          index: false,
        },
        {
          name: "caffeine",
          type: "u64",
          index: false,
        },
        {
          name: "degree",
          type: "u8",
          index: false,
        },
      ],
    },
    {
      name: "UpgradeEvent",
      fields: [
        {
          name: "user",
          type: "publicKey",
          index: false,
        },
        {
          name: "mint",
          type: "publicKey",
          index: false,
        },
        {
          name: "amount",
          type: "u64",
          index: false,
        },
        {
          name: "degreeOld",
          type: "u8",
          index: false,
        },
      ],
    },
    {
      name: "ClaimRewardEvent",
      fields: [
        {
          name: "user",
          type: "publicKey",
          index: false,
        },
        {
          name: "mint",
          type: "publicKey",
          index: false,
        },
        {
          name: "amount",
          type: "u64",
          index: false,
        },
        {
          name: "degree",
          type: "u8",
          index: false,
        },
        {
          name: "caffeine",
          type: "u64",
          index: false,
        },
      ],
    },
    {
      name: "ClaimSecondPartyEvent",
      fields: [
        {
          name: "user",
          type: "publicKey",
          index: false,
        },
        {
          name: "mint",
          type: "publicKey",
          index: false,
        },
        {
          name: "tokenMint",
          type: "publicKey",
          index: false,
        },
        {
          name: "amount",
          type: "u64",
          index: false,
        },
        {
          name: "degree",
          type: "u8",
          index: false,
        },
        {
          name: "caffeine";
          type: "u64";
          index: false;
        }
      ];
    }
  ];
  errors: [
    {
      code: 6000;
      name: "CaffeineNotEnough";
      msg: "Caffeine not enough";
    },
    {
      code: 6001;
      name: "DegreeIsIllegal";
      msg: "Degree is not legal";
    },
    {
      code: 6002;
      name: "OpenRewardTimeErr";
      msg: "Open reward time should greater than now";
    },
    {
      code: 6003;
      name: "UrlTooLong";
      msg: "Url too long";
    },
    {
      code: 6004;
      name: "OperationOverRewardTime";
      msg: "Mint, upgrade, add transfer operation is over open reward time";
    },
    {
      code: 6005;
      name: "ClaimNotStart";
      msg: "Claim not start yet, and will be start soon";
    },
    {
      code: 6006;
      name: "NFTIsIllegal";
      msg: "Nft is not legal";
    },
    {
      code: 6007;
      name: "IncorrectSlotHashesPubkey";
      msg: "Incorrect SlotHashes PubKey";
    },
    {
      code: 6008;
      name: "SuspiciousTransaction";
      msg: "Suspicious transaction detected";
    },
    {
      code: 6009;
      name: "SecondOverNeeded";
      msg: "Second party over needed";
    },
    {
      code: 6010;
      name: "MultiplierError";
      msg: "Multiplier error";
    },
    {
      code: 6011;
      name: "UpgradeDegreeError";
      msg: "Upgrade only support less than 5";
    },
    {
      code: 6012;
      name: "ClaimFinished";
      msg: "Claim time is finished";
    },
    {
      code: 6013;
      name: "ActivityMetadataKeyNotMatch";
      msg: "Activity metadata key not match";
    },
    {
      code: 6014;
      name: "ForbidOnlyClaimSecondParty";
      msg: "Forbid only claim second party";
    },
    {
      code: 6015;
      name: "TokenAlreadyClaimed";
      msg: "Token already claimed";
    },
    {
      code: 6016;
      name: "RewardMintNotSupport";
      msg: "reward token mint not support";
    },
    {
      code: 6017;
      name: "AlreadyOpenReward";
      msg: "open reward is already finished";
    }
  ];
};
export const ActivityJSON: ActivityIDL = {
  version: "0.1.0",
  name: "activity",
  instructions: [
    {
      name: "initialize",
      accounts: [
        {
          name: "activityMaster",
          isMut: true,
          isSigner: false,
        },
        {
          name: "caffeineTokenMint",
          isMut: false,
          isSigner: false,
        },
        {
          name: "authority",
          isMut: true,
          isSigner: true,
        },
        {
          name: "mintWrapper",
          isMut: false,
          isSigner: false,
        },
        {
          name: "minter",
          isMut: false,
          isSigner: false,
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "bump",
          type: "u8",
        },
        {
          name: "openRewardTimestamp",
          type: "i64",
        },
        {
          name: "secondPartyNum",
          type: "u8",
        },
        {
          name: "crmExchangeRate",
          type: "u64",
        },
        {
          name: "crmPriceDecimal",
          type: "u8",
        },
        {
          name: "url",
          type: "string",
        },
        {
          name: "multipliers",
          type: {
            array: ["u8", 5],
          },
        },
      ],
    },
    {
      name: "addTransferer",
      accounts: [
        {
          name: "activityMaster",
          isMut: true,
          isSigner: false,
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
        },
      ],
      args: [
        {
          name: "idx",
          type: "u8",
        },
        {
          name: "exchangeRate",
          type: "u64",
        },
        {
          name: "decimals",
          type: "u8",
        },
        {
          name: "name",
          type: "string",
        },
      ],
    },
    {
      name: "update",
      accounts: [
        {
          name: "activityMaster",
          isMut: true,
          isSigner: false,
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
        },
      ],
      args: [
        {
          name: "openRewardTimestamp",
          type: {
            option: "i64",
          },
        },
        {
          name: "url",
          type: {
            option: "string",
          },
        },
        {
          name: "opSecondPartyNum",
          type: {
            option: "u8",
          },
        },
        {
          name: "opCrmExchangeRate",
          type: {
            option: "u64",
          },
        },
        {
          name: "opCrmPriceDecimal",
          type: {
            option: "u8",
          },
        },
      ],
    },
    {
      name: "mint",
      accounts: [
        {
          name: "activityMaster",
          isMut: true,
          isSigner: false,
        },
        {
          name: "payerAccount",
          isMut: true,
          isSigner: true,
        },
        {
          name: "caffeineTokenMint",
          isMut: true,
          isSigner: false,
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "mint",
          isMut: true,
          isSigner: true,
        },
        {
          name: "receiverAtaAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
        },
        {
          name: "activityMetadata",
          isMut: true,
          isSigner: false,
        },
        {
          name: "tokenMetadataProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "associatedTokenProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "bump",
          type: "u8",
        },
        {
          name: "degree",
          type: "u8",
        },
      ],
    },
    {
      name: "upgradeNft",
      accounts: [
        {
          name: "activityMaster",
          isMut: true,
          isSigner: false,
        },
        {
          name: "payerAccount",
          isMut: true,
          isSigner: true,
        },
        {
          name: "caffeineTokenMint",
          isMut: true,
          isSigner: false,
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
        },
        {
          name: "nftAtaAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "activityMetadata",
          isMut: true,
          isSigner: false,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [],
    },
    {
      name: "claimReward",
      accounts: [
        {
          name: "activityMaster",
          isMut: true,
          isSigner: false,
        },
        {
          name: "payerAccount",
          isMut: true,
          isSigner: true,
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
        },
        {
          name: "nftAtaAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
        },
        {
          name: "activityMetadata",
          isMut: true,
          isSigner: false,
        },
        {
          name: "mintWrapper",
          isMut: true,
          isSigner: false,
        },
        {
          name: "mintWrapperProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "minter",
          isMut: true,
          isSigner: false,
        },
        {
          name: "rewardsTokenMint",
          isMut: true,
          isSigner: false,
        },
        {
          name: "rewardsTokenAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "recentBlockhashAccount",
          isMut: false,
          isSigner: false,
        },
        {
          name: "instructionSysvarAccount",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [],
    },
    {
      name: "claimSecondParty",
      accounts: [
        {
          name: "activityMaster",
          isMut: true,
          isSigner: false,
        },
        {
          name: "payerAccount",
          isMut: true,
          isSigner: true,
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
        },
        {
          name: "nftAtaAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
        },
        {
          name: "activityMetadata",
          isMut: true,
          isSigner: false,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "transferWrapperProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "mintWrapper",
          isMut: true,
          isSigner: false,
        },
        {
          name: "mintWrapperProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "minter",
          isMut: true,
          isSigner: false,
        },
        {
          name: "rewardsTokenMint",
          isMut: true,
          isSigner: false,
        },
        {
          name: "rewardsTokenAccount",
          isMut: true,
          isSigner: false,
        },
      ],
      args: [],
    },
    {
      name: "claimCaffeine",
      accounts: [
        {
          name: "activityMaster",
          isMut: true,
          isSigner: false,
        },
        {
          name: "payerAccount",
          isMut: true,
          isSigner: true,
        },
        {
          name: "caffeineTokenMint",
          isMut: true,
          isSigner: false,
        },
        {
          name: "caffeineTokenAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "rewardsTokenMint",
          isMut: true,
          isSigner: false,
        },
        {
          name: "rewardsTokenAccount",
          isMut: true,
          isSigner: false,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "mintWrapper",
          isMut: true,
          isSigner: false,
        },
        {
          name: "mintWrapperProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "minter",
          isMut: true,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "burnAmount",
          type: "u64",
        },
      ],
    },
    {
      name: "closePdaAccount",
      accounts: [
        {
          name: "activityMaster",
          isMut: true,
          isSigner: false,
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
        },
      ],
      args: [],
    },
  ],
  accounts: [
    {
      name: "ActivityMaster",
      type: {
        kind: "struct",
        fields: [
          {
            name: "authority",
            type: "publicKey",
          },
          {
            name: "caffeineTokenMint",
            type: "publicKey",
          },
          {
            name: "bump",
            type: "u8",
          },
          {
            name: "mintWrapper",
            type: "publicKey",
          },
          {
            name: "minter",
            type: "publicKey",
          },
          {
            name: "openRewardTimestamp",
            type: "i64",
          },
          {
            name: "secondPartyNum",
            type: "u8",
          },
          {
            name: "crmExchangeRate",
            type: "u64",
          },
          {
            name: "crmPriceDecimal",
            type: "u8",
          },
          {
            name: "url",
            type: "string",
          },
          {
            name: "cremaKeys",
            type: {
              vec: {
                defined: "CremaKey",
              },
            },
          },
          {
            name: "transfers",
            type: {
              vec: {
                defined: "TransferMeta",
              },
            },
          },
        ],
      },
    },
    {
      name: "ActivityMetadata",
      type: {
        kind: "struct",
        fields: [
          {
            name: "caffeine",
            type: "u64",
          },
          {
            name: "degree",
            type: "u8",
          },
          {
            name: "mint",
            type: "publicKey",
          },
          {
            name: "mintUser",
            type: "publicKey",
          },
          {
            name: "seed",
            type: "u8",
          },
          {
            name: "isCrmClaimed",
            type: "bool",
          },
          {
            name: "crmClaimedAmount",
            type: "u64",
          },
          {
            name: "isClaimed",
            type: {
              vec: "bool",
            },
          },
          {
            name: "claimAmounts",
            type: {
              vec: "u64",
            },
          },
        ],
      },
    },
  ],
  types: [
    {
      name: "CremaKey",
      type: {
        kind: "struct",
        fields: [
          {
            name: "level",
            type: "u8",
          },
          {
            name: "itemsMinted",
            type: "i64",
          },
          {
            name: "itemsNormalClaimed",
            type: "i64",
          },
          {
            name: "itemsLuckyClaimed",
            type: "i64",
          },
          {
            name: "multiplier",
            type: "u8",
          },
        ],
      },
    },
    {
      name: "TransferMeta",
      type: {
        kind: "struct",
        fields: [
          {
            name: "mint",
            type: "publicKey",
          },
          {
            name: "decimals",
            type: "u8",
          },
          {
            name: "transferWrapper",
            type: "publicKey",
          },
          {
            name: "transferer",
            type: "publicKey",
          },
          {
            name: "tokensClaimed",
            type: "u64",
          },
          {
            name: "exchangeRate",
            type: "u64",
          },
          {
            name: "priceDecimal",
            type: "u8",
          },
          {
            name: "name",
            type: "string",
          },
        ],
      },
    },
  ],
  events: [
    {
      name: "MintEvent",
      fields: [
        {
          name: "user",
          type: "publicKey",
          index: false,
        },
        {
          name: "mint",
          type: "publicKey",
          index: false,
        },
        {
          name: "caffeine",
          type: "u64",
          index: false,
        },
        {
          name: "degree",
          type: "u8",
          index: false,
        },
      ],
    },
    {
      name: "UpgradeEvent",
      fields: [
        {
          name: "user",
          type: "publicKey",
          index: false,
        },
        {
          name: "mint",
          type: "publicKey",
          index: false,
        },
        {
          name: "amount",
          type: "u64",
          index: false,
        },
        {
          name: "degreeOld",
          type: "u8",
          index: false,
        },
      ],
    },
    {
      name: "ClaimRewardEvent",
      fields: [
        {
          name: "user",
          type: "publicKey",
          index: false,
        },
        {
          name: "mint",
          type: "publicKey",
          index: false,
        },
        {
          name: "amount",
          type: "u64",
          index: false,
        },
        {
          name: "degree",
          type: "u8",
          index: false,
        },
        {
          name: "caffeine",
          type: "u64",
          index: false,
        },
      ],
    },
    {
      name: "ClaimSecondPartyEvent",
      fields: [
        {
          name: "user",
          type: "publicKey",
          index: false,
        },
        {
          name: "mint",
          type: "publicKey",
          index: false,
        },
        {
          name: "tokenMint",
          type: "publicKey",
          index: false,
        },
        {
          name: "amount",
          type: "u64",
          index: false,
        },
        {
          name: "degree",
          type: "u8",
          index: false,
        },
        {
          name: "caffeine",
          type: "u64",
          index: false,
        },
      ],
    },
  ],
  errors: [
    {
      code: 6000,
      name: "CaffeineNotEnough",
      msg: "Caffeine not enough",
    },
    {
      code: 6001,
      name: "DegreeIsIllegal",
      msg: "Degree is not legal",
    },
    {
      code: 6002,
      name: "OpenRewardTimeErr",
      msg: "Open reward time should greater than now",
    },
    {
      code: 6003,
      name: "UrlTooLong",
      msg: "Url too long",
    },
    {
      code: 6004,
      name: "OperationOverRewardTime",
      msg: "Mint, upgrade, add transfer operation is over open reward time",
    },
    {
      code: 6005,
      name: "ClaimNotStart",
      msg: "Claim not start yet, and will be start soon",
    },
    {
      code: 6006,
      name: "NFTIsIllegal",
      msg: "Nft is not legal",
    },
    {
      code: 6007,
      name: "IncorrectSlotHashesPubkey",
      msg: "Incorrect SlotHashes PubKey",
    },
    {
      code: 6008,
      name: "SuspiciousTransaction",
      msg: "Suspicious transaction detected",
    },
    {
      code: 6009,
      name: "SecondOverNeeded",
      msg: "Second party over needed",
    },
    {
      code: 6010,
      name: "MultiplierError",
      msg: "Multiplier error",
    },
    {
      code: 6011,
      name: "UpgradeDegreeError",
      msg: "Upgrade only support less than 5",
    },
    {
      code: 6012,
      name: "ClaimFinished",
      msg: "Claim time is finished",
    },
    {
      code: 6013,
      name: "ActivityMetadataKeyNotMatch",
      msg: "Activity metadata key not match",
    },
    {
      code: 6014,
      name: "ForbidOnlyClaimSecondParty",
      msg: "Forbid only claim second party",
    },
    {
      code: 6015,
      name: "TokenAlreadyClaimed",
      msg: "Token already claimed",
    },
    {
      code: 6016,
      name: "RewardMintNotSupport",
      msg: "reward token mint not support",
    },
    {
      code: 6017,
      name: "AlreadyOpenReward",
      msg: "open reward is already finished",
    },
  ],
};
export const ActivityErrors = generateErrorMap(ActivityJSON);
